import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=24509dec&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=24509dec&prod&lang=scss&scoped=true"
import style1 from "./profile.vue?vue&type=style&index=1&id=24509dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24509dec",
  null
  
)

export default component.exports